namespace Gamification.Gamification {
    
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.resizable()
    @Serenity.Decorators.maximizable()
    export class ApiScriptUtenteDialog2 extends Serenity.TemplatedDialog<any> {

        static initializePage() {

            $(function () {
                $('#LaunchDialogButton').click(function (e) {
                    (new ApiScriptUtenteDialog2()).dialogOpen();
                });
            });
        }

        protected onDialogOpen() {
            super.onDialogOpen();

        }

        protected getTemplate() {
            return "<canvas id='~_Chart'></div>";
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.title = 'Orders by Shipper';
            return opt;
        }
    }    
}